import { TActivityState } from './domain';

export const DEFAULT_ACTIVITY_STATE: TActivityState = {
    showReviews: false,
    noMoreReviews: false,
    reviewsLoading: false,
    activityId: '',
    partnerSlug: '',
    reviews: [],
};
